module.exports = __webpack_public_path__ + "static/media/ram.42416e83.svg";